import { createEnum } from '@/utils.js';

export const VIEW_CHAT_MESSAGES_PERMISSION = createEnum({
  ALLOWED: 'ALLOWED',
  DENIED: 'DENIED',
});
